<template>
  <div class="col-sm-12 nopads">
    <div class="list-content result-table">

        <vue3-datatable
            ref="resultTable"
            :rows="recordData"
            :columns="fields"
            :pagination="false"
            :sticky-header="true"
            :height="recordData.length > 10 ? '40vh' : '100%'"
            :sortable="true"
            skin="bh-table-compact"
            row-class="routa-table-row"
            cell-class="routa-table-cell"
        >

        <template #start_time="row">
          {{ toLocalTime(row.value.start_time) }}
        </template>
        <template #area_type="row">
          {{ areaTypeToText(row.value) }}
        </template>
        <template #vehicle="row">
          {{ row.value.vehicle ? row.value.vehicle.make + ' ' + row.value.vehicle.vehicle_model + ' ' + row.value.vehicle.license_plate : '' }}
        </template>
        <template #amount="row">
          {{ row.value.amount ? row.value.amount.toFixed(2) : '' }}
        </template>
        <template #surface_density="row">
          {{ calculateDensity(row.value) }}
        </template>
        <template #object_number="row">
          {{row.value.work_order && row.value.work_order.object_number > 0 ? row.value.work_order.object_number : '' }}
        </template>
        <template #task_type="row">
          {{ row.value.work_order ? row.value.work_order.task_type.name : '' }}
        </template>
        </vue3-datatable>
    </div>
  </div>
</template>

<script>
import {timeUtils} from "@/components/mixins/TimeUtils";
import {units} from "@/components/mixins/DeliveryNoteMixin";
import Vue3Datatable from "@bhplugin/vue3-datatable";
export default {
    name: "PointUnloadRecordTable",
    components: {Vue3Datatable},
    mixins: [timeUtils],
    props: {
        records: {
            type: Array,
            default() {
                return []
            }
        }
    },
    data: function () {
        return {
            fields: [
                {field: "id", title: this.$t('common.id'), sort: false, headerClass: 'routa-table-header'},
                {field: "start_time", title: this.$t('delivery_note.date'), sort: false, headerClass: 'routa-table-header'},
                {field: "area_type", title: this.$t('contract_reports.unload_records.area_type'), sort: false, headerClass: 'routa-table-header'},
                {field: "vehicle", title: this.$t('contract_reports.unload_records.vehicle'), sort: false, headerClass: 'routa-table-header'},
                {field: "road_name", title: this.$t('contract_reports.unload_records.road_name'), sort: false, headerClass: 'routa-table-header'},
                {field: "road_num", title: this.$t('contract_reports.unload_records.road_num'), sort: false, headerClass: 'routa-table-header'},
                {field: "road_sec", title: this.$t('contract_reports.unload_records.road_sec'), sort: false, headerClass: 'routa-table-header'},
                {field: "distance", title: this.$t('contract_reports.unload_records.road_distance'), sort: false, headerClass: 'routa-table-header'},
                {field: "area_size", title: this.$t('contract_reports.unload_records.area_size'), sort: false, headerClass: 'routa-table-header'},
                {field: "amount", title: this.$t('contract_reports.unload_records.amount'), sort: false, headerClass: 'routa-table-header'},
                {field: "unit", title: this.$t('contract_reports.unload_records.unit')},
                {field: "surface_density", title: units.KILOGRAMS_PER_SQUARE_METRE, sort: false, headerClass: 'routa-table-header'},
                {field: "object_number", title: this.$t('orders.object'), sort: false, headerClass: 'routa-table-header'},
                {field: "task_type", title: this.$t('work_report.task_type'), sort: false, headerClass: 'routa-table-header'}
            ]
        }
    },
    computed: {
        recordData() {
            let data = this.records
            return data.sort((a, b) => {
                return new Date(a.start_time) - new Date(b.start_time)
            })
        }
    },
    methods: {
        areaTypeToText: function (record) {
            let area = ''
            if (record.area_size <= 50) area = 1
            else if (record.area_size > 50 && record.area_size <= 150) area = 2
            else if (record.area_size > 150 && record.area_size <= 500) area = 3
            else if (record.area_size > 500) area = 4

            switch (area) {
                case 1:
                    return this.$t('area_types.type_0_50')
                case 2:
                    return this.$t('area_types.type_50_150')
                case 3:
                    return this.$t('area_types.type_150_500')
                case 4:
                    return this.$t('area_types.type_bus_stops')
            }
            return area
        },
        calculateDensity: function (record) {
            // Calculate if necessary info provided and unit is tons
            if ((record.area_size > 0 && record.amount > 0) && record.unit === units.TONS) {
                // Tons to kilograms
                let amount = record.amount * 1000
                let density = amount / record.area_size
                return density.toFixed(2);
            }
            return ''
        }
    }
}
</script>
